module.exports = __webpack_public_path__ + "img/icon-save.1cc959b0.svg";